<script>
    export default {
        props: {
            title: String,
            value: String,
            error: String,
            required: Boolean,
            maximumlength: [Number],
            placeholder: {
                type: String,
                default: ''
            }
        },
        methods: {
            change(val) {
                this.$emit('input', val)
            },
            NumbersOnly(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault()
                } else {
                    return true;
                }
            }
        },
    }
</script>

<template>
    <div>
        <label v-if="title.length">
            {{ title }}
            <span v-if="required" class="text-danger">*</span>
        </label>
        <input
            type="text"
            class="form-control"
            :placeholder="placeholder.length ? placeholder : title"
            :value="value"
            @input="change($event.target.value)"
            v-on:keypress="NumbersOnly"
            :maxlength="maximumlength"
            :class="{
                'is-invalid': error,
            }"
        />
        <div
            v-if="error"
            class="invalid-feedback"
        >
            {{ error }}
        </div>
    </div>    
</template>